import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';

import {EntitiesComponent} from '../../../entities.component';

import {LoginService} from '../../../../pages/login/login.service';
import {AppService, UserService} from '../../../../shared/service/user.service';
import {AuthService} from '../../../../shared/service/auth.service';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';
import {environment} from '../../../../../environments/environment.prod';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit, OnDestroy {

  AuthService = AuthService;
  baseWebSocketURL: string = environment.baseWebSocketURL;
  @Input() actionColumnWidth?: number;
  @Input() activeModule?: string;

  @Input() onMessage: () => void = () => {
  };
  @Input() selectionMode: string = 'single';
  selectedItem: any;

  user: any;
  displayName?: string;

  changingPassword?: boolean;
  submittedPassword?: boolean;
  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    newPasswordVerify: ['', Validators.required]
  });
  changePasswordError?: string;

  webSocket?: WebSocket;
  listening?: boolean;
  isSuccess?: boolean;
  title?: string;
  paymentDone?: boolean;

  remoteModalVisible: boolean = false;
  termsModalVisible: boolean = false;
  agreeRemote: boolean = false;
  supportReason: string = '';
  appDownloadQrVisible: boolean = false;
  appDownloadPlatform?: 'android' | 'ios';
  remoteAppNotFoundVisible: boolean = false;
  private readonly remoteSupportDownloadUrl = 'assets/tools/IAM_Remote_Support_Setup_v1.0.0.exe.zip';
  private readonly remoteSupportAppUri = 'iamsupport://';
  private readonly appDownloadConfig = {
    android: {
      title: 'Tải mobile app',
      subtitle: 'Quét mã QR hoặc mở Google Play để tải ứng dụng.',
      qrImage: 'assets/images/qrcode-android.png',
      downloadUrl: 'https://play.google.com/store/apps/details?id=com.etax.icanhan&hl=vi'
    },
    ios: {
      title: 'Tải mobile app',
      subtitle: 'Quét mã QR hoặc mở App Store để tải ứng dụng.',
      qrImage: 'assets/images/qrcode-ios.png',
      downloadUrl: 'https://apps.apple.com/vn/app/etax-mobile/id1589750682'
    }
  };


  constructor(
    private fb: FormBuilder,
    private router: Router,
    public entities: EntitiesComponent,
    private loginService: LoginService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.user = UserService.getUser();
    if (this.user && this.user.partyId) {
      if (AuthService.hasRoles(['Customer'])) {
        this.displayName = this.user.partyTaxId;
      } else {
        this.displayName = this.user.partyName;
      }
      this.initWebSocket();
    }
  }

  initWebSocket(): void {
    const origin = location.origin.replace('http', 'ws').replace('https', 'wws');
    this.webSocket = new WebSocket(`${origin}/${this.baseWebSocketURL}`);
    this.webSocket.addEventListener('open', () => {
      this.webSocket?.send('subscribe:BidvPaymentResult');
    });

    this.webSocket.onclose = (e) => {
      if (e.reason !== 'unmount') {
        this.initWebSocket();
      }
    }
    this.webSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.topic === 'BidvPaymentResult') {
        if (this.onMessage) {
          this.onMessage();
        }
        if (this.listening) {
          this.listening = false;
          this.paymentDone = true;
          if (data.showAlert === true) {
            this.isSuccess = true;
            this.title = data.title;
          } else {
            this.isSuccess = false;
            this.title = 'Có lỗi xảy ra!';
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.webSocket) {
      this.webSocket.close(3010, 'unmount');
    }
  }

  openRemoteSupport(event: Event): void {
    event.preventDefault();
    this.remoteModalVisible = true;
    this.agreeRemote = false;
    this.supportReason = '';
  }

  downloadRemoteSupport(): void {
    window.location.href = this.remoteSupportDownloadUrl;
  }

  closeRemoteModal(): void {
    this.remoteModalVisible = false;
  }

  openTermsModal(): void {
    this.termsModalVisible = true;
  }

  closeTermsModal(): void {
    this.termsModalVisible = false;
  }

  openAppDownloadQr(event: Event, platform: 'android' | 'ios'): void {
    event.preventDefault();
    this.appDownloadPlatform = platform;
    this.appDownloadQrVisible = true;
  }

  closeAppDownloadQr(): void {
    this.appDownloadQrVisible = false;
  }

  openAppDownloadLink(): void {
    if (!this.appDownloadPlatform) return;
    window.open(this.currentAppDownload.downloadUrl, '_blank', 'noopener,noreferrer');
  }

  get currentAppDownload(): any {
    return this.appDownloadConfig[this.appDownloadPlatform || 'android'];
  }

  agreeFromTerms(): void {
    this.agreeRemote = true;
    this.termsModalVisible = false;
  }

  submitRemoteSupport(event: Event): void {
    event.preventDefault();
    if (!this.agreeRemote) return;

    try {
      const issue = this.supportReason.trim() !== ''
        ? this.supportReason.trim()
        : 'Yêu cầu hỗ trợ từ xa qua Website';

      fetch('https://admin-tool.iamsoftware.com.vn/api/v1/remote-support/ready', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          source: 'Web',
          issue,
          machineName: 'Khách hàng từ Web',
          taxCode: this.user?.partyTaxId || 'UNKNOWN'
        })
      }).catch((error) => {
        console.error('Lỗi khi gửi yêu cầu hỗ trợ lên server:', error);
      });
    } catch (error) {
      console.error(error);
    }

    const requestId = Math.random().toString(36).substring(2, 15);
    const callbackUrl = `${window.location.origin}/assets/callback.html?requestId=${requestId}`;
    const appUri = `${this.remoteSupportAppUri}connect?id=&callback=${callbackUrl}`;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = appUri;
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 100);

    const startTime = Date.now();
    const storageKey = `remote-support-success-${requestId}`;

    const checkInterval = setInterval(() => {
      const isSuccess = localStorage.getItem(storageKey) === 'true';
      const elapsed = Date.now() - startTime;

      if (isSuccess) {
        clearInterval(checkInterval);
        localStorage.removeItem(storageKey);
      } else if (elapsed > 2500) {
        clearInterval(checkInterval);
        localStorage.removeItem(storageKey);
        this.remoteAppNotFoundVisible = true;
      }
    }, 200);

    this.remoteModalVisible = false;
  }

  changePassword(): void {
    this.changePasswordForm.reset();
    this.changingPassword = true;
  }

  onChangePassword(): void {
    if (!this.submittedPassword && this.changePasswordForm.valid) {
      this.submittedPassword = true;
      this.changePasswordError = '';

      this.loginService.changePassword(this.changePasswordForm.value).subscribe(({isSuccess, messages}) => {
        this.submittedPassword = false;
        if (isSuccess === 'Y') {
          this.toastService.setMessage({severity: Severity.SUCCESS, detail: messages});
          this.changingPassword = false;
        } else {
          this.changePasswordError = messages;
        }
      }, () => {
        this.submittedPassword = false;
      });
    }
  }

  private buildKeycloakLogoutUrl(): string {
    const keycloakBase = 'https://sso.iamsoftware.com.vn';
    const realm = 'apps_iam';
    const clientId = 'iam-tncn';
    const redirectUri = encodeURIComponent('https://pit.iamsoftware.com.vn/login');

    return `${keycloakBase}/realms/${realm}/protocol/openid-connect/logout`
      + `?client_id=${clientId}`
      + `&post_logout_redirect_uri=${redirectUri}`;
  }

  logout(): void {
    this.loginService.logout().subscribe(() => {
      this.clearLocalSessionAndGoLogin();
    }, () => {
      this.clearLocalSessionAndGoLogin();
    });
  }

  private clearLocalSessionAndGoLogin(): void {
    AppService.removeAll();
    UserService.removeAll();
    this.router.navigateByUrl('/login').then();
  }

}
